var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70781 11.9583H27.1457C27.6174 11.9583 27.9998 12.3408 27.9998 12.8125C27.9998 13.2842 27.6174 13.6667 27.1457 13.6667H8.70781L14.083 19.0418C14.4166 19.3754 14.4166 19.9162 14.083 20.2498C13.7494 20.5834 13.2086 20.5834 12.875 20.2498L6.04168 13.4165C5.70811 13.0829 5.70811 12.5421 6.04168 12.2085L12.875 5.37518C13.2086 5.04161 13.7494 5.04161 14.083 5.37518C14.4166 5.70875 14.4166 6.24958 14.083 6.58315L8.70781 11.9583ZM0.666504 0.854167C0.666504 0.382423 1.04893 0 1.52067 0C1.99241 0 2.37484 0.382423 2.37484 0.854167V24.7708C2.37484 25.2426 1.99241 25.625 1.52067 25.625C1.04893 25.625 0.666504 25.2426 0.666504 24.7708V0.854167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fa100c6e7e8faf3b31510f00ff8a33e2.svg";
export { ForwardRef as ReactComponent };